/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/oxytocin/"

const OXYTOCIN: CommunityData = {
  code: "oxytocin",
  inviteCode: "oxytocin",
  name: "Oxytocin",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/oxy-931`,
  waitlist: false,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#000000",
      hero: {
        desktop: `https://media.werz.at/community-assets/oxytocin/mobile-landing-background.mp4?type=video`,
        mobile: `https://media.werz.at/community-assets/oxytocin/mobile-landing-background.mp4?type=video`,
        style: "bg-[#222222]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[120px] h-[30px] sm:w-[200px] sm:h-[52px]",
      },
      werzLogoColor: "#FFFFFF",
      title: "font-['EuroStyleNormal'] text-[28px] leading-[120%] text-[#ffffff]",
      text: "font-['EuroStyleNormal'] text-[16px] leading-[120%] text-[#ffffff]",
      button:
        "font-['AerobladeDEMORegular'] text-[16px] leading-[120%] p-4 bg-[#000000] border-2 border-[#ff0084] text-[#ffffff] cursor-pointer w-fit",
      input: {
        base: "font-['EuroStyleNormal'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#222222] text-[#ffffff]",
        border: "#444444",
        borderFocus: "#6d6d6d",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['EuroStyleNormal'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['EuroStyleNormal'] text-[14px] leading-[120%] text-[#6d6d6d]",
      skipButton:
        "font-['EuroStyleNormal'] text-[14px] leading-[120%] text-[#6d6d6d] cursor-pointer",
      modal: {
        container: "bg-[#222222] px-[40px] py-[48px]",
        title: "font-['EuroStyleNormal'] text-[24px] leading-[120%] text-[#ffffff] text-center",
        text: "font-['EuroStyleNormal'] text-[14px] leading-[120%] text-[#6d6d6d] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#ffffff] bg-[#000000] font-['EuroStyleNormal'] text-[16px] leading-[120%] text-center",
        otpBorder: "#444444",
        otpBorderFocus: "#6d6d6d",
      },
    },
    global: {
      werzLogoColor: "#FFF",
      counterColor: "#FFF",
      logo: {
        src: "https://media.werz.at/community/icon/cmgrlwe6400009kn4qij06m6h.jpg?uploadTime=1760520300352&type=image&v=1762238616236",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[200px] h-[52px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "!p-0 !gap-0",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.png`,
      bgMobile: `${S3_PREFIX}web-background-mobile.png`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.png`,
      mainFont: "font-['EuroStyleNormal']",
      primaryButton:
        "bg-[#000000] border-2 border-[#ff0084] px-[18px] py-[18px] !text-[#ffffff] font-['AerobladeDEMORegular'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#444444]",
      separator: "border-[#444444]",
      item: "font-['EuroStyleNormal'] text-[22px] text-[#ffffff] uppercase text-left leading-[120%] gap-x-[10px] text-opacity-50 text-center border-b border-[#444444] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] border border-[#ffffff00] !pb-8",
      titles:
        "text-[#ffffff] font-['EuroStyleNormal'] text-[32px] uppercase text-left leading-[90%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#6d6d6d] font-['EuroStyleNormal'] text-[18px] text-left leading-[100%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#ffffff00]",
        sectionTitle:
          "text-[#ffffff] font-['EuroStyleNormal'] text-[32px] uppercase text-left leading-[90%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#ffffff] font-['EuroStyleNormal'] text-[16px] text-left leading-[110%]",
          subtitle:
            "text-[#6d6d6d] font-['EuroStyleNormal'] text-[14px] text-left leading-[130%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#ffffff00]",
        sectionTitle:
          "text-[#ffffff] font-['EuroStyleNormal'] text-[32px] uppercase text-left leading-[90%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title: "text-[#ffffff] font-['EuroStyleNormal'] text-[23px] text-left leading-[90%]",
          subtitle:
            "text-[#6d6d6d] font-['EuroStyleNormal'] text-[15px] text-left leading-[100%] mt-2",
          location:
            "text-[#6d6d6d] font-['EuroStyleNormal'] text-[15px] text-left leading-[100%] mt-1",
          date: "text-[#6d6d6d] font-['EuroStyleNormal'] text-[15px] text-left leading-[100%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#ffffff] font-['EuroStyleNormal'] text-[30px] uppercase text-left leading-[90%]",
        text: "text-[#ffffff] font-['EuroStyleNormal'] text-[24px] text-left leading-[100%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffffff] font-['EuroStyleNormal'] text-[32px] uppercase text-left leading-[90%] !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: "https://media.werz.at/community-assets/oxytocin/web-background-non-member.png",
      bgMobile: "https://media.werz.at/community-assets/oxytocin/web-background-non-member.png",
      bgColor: "#000000",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#000000]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#ffffff00]",
        name: "text-[#ffffff] font-['EuroStyleNormal'] text-[32px] uppercase leading-[28.8px] text-center text-center mt-4 mb-1",
        location:
          "font-['EuroStyleNormal'] uppercase leading-[21.6px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#ffffff] font-['EuroStyleNormal'] text-[24px] leading-[100%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#FFF",
        button:
          "bg-[#000000] border-2 border-[#ff0084] px-[16px] py-[12px] text-[#ffffff] font-['EuroStyleNormal'] text-[18px] text-left leading-[100%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#ffffff00] text-[#ffffff] font-['EuroStyleNormal'] text-[24px] leading-[100%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#000000] border border-[#ffffff00]",
          title:
            "font-['EuroStyleNormal'] uppercase leading-[21.6px] text-[16px] text-left text-center mb-1",
          text: "text-[#ffffff] font-['EuroStyleNormal'] text-[24px] leading-[100%] text-center text-center",
          button:
            "bg-[#000000] border-2 border-[#ff0084] px-[16px] py-[12px] text-[#ffffff] font-['EuroStyleNormal'] text-[18px] text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['EuroStyleNormal'] uppercase leading-[21.6px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#ffffff00]",
          duration: "text-[#6d6d6d] font-['EuroStyleNormal'] text-[15px] text-left",
          name: "text-[#ffffff] font-['EuroStyleNormal'] uppercase leading-[21.6px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#FFF",
          media: "overflow-hidden m-2 border border-[#ffffff00]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#000000] border border-[#ffffff00]",
          name: "text-[#ffffff] font-['EuroStyleNormal'] uppercase leading-[21.6px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#ffffff] border border-[#ffffff00] text-[#000000] font-['EuroStyleNormal'] text-[23px] uppercase leading-[20.7px] text-center",
          duration: "text-[#6d6d6d] font-['EuroStyleNormal'] text-[15px] text-left",
          location: "text-[#6d6d6d] font-['EuroStyleNormal'] text-[15px] text-left",
          button:
            "bg-[#000000] border-2 border-[#ff0084] px-[16px] py-[12px] text-[#ffffff] font-['EuroStyleNormal'] text-[18px] text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#ffffff00]",
            name: "text-[#ffffff] font-['EuroStyleNormal'] leading-[20.7px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#ffffff] font-['EuroStyleNormal'] leading-[20.7px] text-[14px] text-left",
            link: "text-[#6d6d6d] font-['EuroStyleNormal'] text-[18px] text-left",
            status: "text-[#ffffff] font-['EuroStyleNormal'] leading-[90%] text-[14px] text-left",
            button:
              "bg-[#000000] border-2 border-[#ff0084] px-[16px] py-[12px] text-[#ffffff] font-['EuroStyleNormal'] text-[18px] text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#ffffff] font-['EuroStyleNormal'] text-[24px] leading-[100%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#ffffff00] text-[#ffffff] font-['EuroStyleNormal'] text-[24px] leading-[100%] text-center",
        header:
          "text-[#ffffff] font-['EuroStyleNormal'] uppercase leading-[21.6px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#ffffff00]",
          name: "text-[#ffffff] font-['EuroStyleNormal'] uppercase leading-[21.6px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#FFF",
          created: "text-[#6d6d6d] font-['EuroStyleNormal'] text-[15px] text-left",
          media: "overflow-hidden m-2 border border-[#ffffff00]",
        },
        seeAllNews:
          "text-[#ffffff] font-['EuroStyleNormal'] text-[24px] leading-[100%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#ffffff00] text-[#ffffff] font-['EuroStyleNormal'] text-[24px] leading-[100%] text-center",
        header:
          "text-[#ffffff] font-['EuroStyleNormal'] uppercase leading-[21.6px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#ffffff00]",
          coverUrl: "overflow-hidden m-2 border border-[#ffffff00]",
          duration: "text-[#6d6d6d] font-['EuroStyleNormal'] text-[15px] text-left",
          liveType: "text-[#6d6d6d] font-['EuroStyleNormal'] text-[15px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#ffffff] rounded-full",
          playIconColor: "#ffffff",
          playIconBackgroundColor: "#ff0084",
          playIconBorderColor: "#ffffff",
          start: "text-[#6d6d6d] font-['EuroStyleNormal'] text-[15px] text-left",
          title:
            "text-[#ffffff] font-['EuroStyleNormal'] uppercase leading-[21.6px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#ffffff] font-['EuroStyleNormal'] text-[24px] leading-[100%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#ffffff00] text-[#ffffff] font-['EuroStyleNormal'] text-[24px] leading-[100%] text-center",
        header:
          "text-[#ffffff] font-['EuroStyleNormal'] uppercase leading-[21.6px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#ffffff00]",
          name: "text-[#ffffff] font-['EuroStyleNormal'] uppercase leading-[21.6px] text-[16px] text-left",
          triangleIconColor: "#FFF",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#ffffff00]",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#6d6d6d] font-['EuroStyleNormal'] text-[15px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] border border-[#ffffff00] !pb-8",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#ffffff00]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4",
        title:
          "text-[#ffffff] font-['EuroStyleNormal'] text-[32px] uppercase text-left leading-[90%]",
        subtitle:
          "text-[#6d6d6d] font-['EuroStyleNormal'] text-[18px] text-left leading-[100%] mb-4 mt-2",
        button:
          "bg-[#000000] border-2 border-[#ff0084] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['AerobladeDEMORegular'] !text-[16px] text-left leading-[100%]",
        questions: "text-[18px] text-left leading-[100%] text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#ffffff00]",
        header:
          "text-[#ffffff] font-['EuroStyleNormal'] text-[30px] uppercase text-left leading-[90%]",
        text: "text-[#ffffff] font-['EuroStyleNormal'] text-[18px] text-left leading-[100%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#ffffff00]",
        header:
          "text-[#ffffff] font-['EuroStyleNormal'] text-[30px] uppercase text-left leading-[90%]",
        text: "text-[#ffffff] font-['EuroStyleNormal'] text-[18px] text-left leading-[100%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#ffffff00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['EuroStyleNormal'] text-[30px] uppercase text-left leading-[90%]",
        text: "text-[#ffffff] font-['EuroStyleNormal'] text-[18px] text-left leading-[100%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['EuroStyleNormal'] text-[32px] uppercase text-left leading-[90%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000] border-2 border-[#ff0084] px-[16px] py-[12px] text-[#ffffff] font-['EuroStyleNormal'] text-[18px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#000000] border-b border-[#ffffff00] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['EuroStyleNormal'] text-[23px] text-left leading-[90%] mb-1",
          description:
            "text-[#6d6d6d] font-['EuroStyleNormal'] text-[18px] text-left leading-[100%] mb-1 flex flex-row",
          price: "text-[#6d6d6d] font-['EuroStyleNormal'] text-[23px] text-left leading-[90%]",
          quantity: "text-[#ffffff] font-['EuroStyleNormal'] text-[18px] text-left leading-[100%]",
          status: "text-[#6d6d6d] font-['EuroStyleNormal'] text-[23px] text-left leading-[90%]",
          counterContainer:
            "bg-[#000000] border-2 border-[#ff0084] px-[16px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#000000] border-2 border-[#ff0084] px-[16px] py-[12px] text-[#ffffff] font-['EuroStyleNormal'] text-[18px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default OXYTOCIN
